import styled from "styled-components";
import { getColor } from "@/pipes/theme.pipe";

export const ScrollToTopStyled = styled.button`
    position: fixed;
    bottom: 20px;
    right: 20px;
    width: 50px;
    height: 50px;
    background-color: #15229e;
    color: white;
    border: none;
    border-radius: 50%;
    display: ${({ $visible }) => ($visible ? "flex" : "none")};
    justify-content: center;
    align-items: center;
    cursor: pointer;
    z-index: 1000;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    transition: opacity 0.3s ease, background-color 0.3s ease;

    &:hover {
        background: ${getColor("natural", "900")};

        svg {
            fill: #15229e;
            
            path {
                fill: #15229e;
            }
        }
    }

    svg {
        width: 24px;
        height: 24px;
        fill: white;
    }
`;
